import React from 'react';
// import { Link } from 'react-router-dom';
//import FontAwesome from 'react-fontawesome';
import { translate } from 'react-i18next';
import cx from '../../../../styles';
import { gtmSend } from '../../../../helpers';
import { isBeYeuTemplate } from '../../../../config';

const ArticleList = ({articles, length=5, t, match}) => {

    if (isBeYeuTemplate) return null

    return (
        <div className={cx("shadow-card", "related-article-posts", "article-list")}>
            <div className={cx("header-wrap")}>
                <div>{t('article_title')}</div>
            </div>
            <ul>
                {
                    articles.slice(0, length).map((article, i) => {
                        return (
                            <li key={i} className={cx('pointer-click','article-section-wrapper')}>
                                <div>
                                    <a href={`${article.link}?utm_source=community&utm_medium=posts&utm_campaign=related`} target="_blank" rel="noopener noreferrer" onClick={() => {gtmSend('dynamic', 'Related Article', 'click', match.path); gtmSend('cw_article_click', 'Article', 'Article Click', 'Community - Article List', 0, {article_id: `${article.id}`, article_title: `${article.title}`, article_author: `${article.author.nice_name}`, article_published_date: `${article.date_gmt}`, article_type: `${article.type}`, article_category: `${article.category[0].name}`})}}>
                                        <img src={article.image} alt="article cover" loading="lazy"/>
                                    </a>
                                </div>
                                    
                                <div className={cx('related-article-title')}>
                                    <a href={`${article.link}?utm_source=community&utm_medium=posts&utm_campaign=related`} target="_blank" rel="noopener noreferrer" dangerouslySetInnerHTML={{__html: article.title}} onClick={() => {gtmSend('dynamic', 'Related Article', 'click', match.path); gtmSend('cw_article_click', 'Article', 'Article Click', 'Community - Article List', 0, {article_id: `${article.id}`, article_title: `${article.title}`, article_author: `${article.author.nice_name}`, article_date: `${article.date_gmt}`, article_type: `${article.type}`, article_category: `${article.category[0].name}`})}}></a>
                                </div>
                                    {/* <p>
                                        <a href={article.link}>{article.excerpt}</a>
                                    </p> */}
                            </li>
                        );
                    })
                }
            </ul>
        </div>
    );

}

export default translate()(ArticleList);

